import React, { useEffect, useMemo, useState } from 'react';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import GridContainer from 'components/Grid/GridContainer';
import { DataGrid, esES } from '@material-ui/data-grid';
import Button from 'components/CustomButtons/Button';
import { wsGet, wsUpdate } from 'services/WService';
import GridItem from 'components/Grid/GridItem';
import CardBody from 'components/Card/CardBody';
import { Visibility } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';
import Card from 'components/Card/Card';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  dataGrid: {
    '& .row-bonification,.row-bonification.Mui-selected': {
      backgroundColor: '#43ff6b61',
      '&:hover': {
        backgroundColor: '#43ff6b61',
      },
    },
  },
});

const columns = [
  {
    field: 'num_line',
    headerName: 'Num',
    width: 70,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      if (params.row.type === 'B') {
        console.log(params);
        return (
          <>
            {params.value}
            <Link
              to={`/admin/articulos/operaciones/promociones/${params.row.prom_promotion_id}`}
              target="_blank"
            >
              <Visibility style={{ fontSize: 18 }} />
            </Link>
          </>
        );
      }
      return params.value;
    },
  },
  {
    field: 'ItemCode',
    headerName: 'Código',
    width: 120,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'ItemName',
    headerName: 'Producto',
    width: 200,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'units_package',
    headerName: 'NumPerMsr',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'total_units',
    headerName: 'Cantidad',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  { field: 'units', headerName: 'Unidades', width: 100, sortable: false, disableColumnMenu: true },
  {
    field: 'packages',
    headerName: 'Paquetes',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'unit_price_without_igv',
    headerName: 'Precio unitario',
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'package_price_without_igv',
    headerName: 'Precio paquete original',
    width: 150,
    sortable: false,
  },
  { field: 'new_package_price', headerName: 'Nuevo Precio paquete', width: 150, sortable: false },
  {
    field: 'original_package_discount',
    headerName: '% Desc Paquete',
    width: 150,
    editable: false,
    type: 'number',
    sortable: false,
  },
  {
    field: 'new_package_discount',
    headerName: 'Nuevo % Desc Paquete',
    width: 150,
    editable: true,
    type: 'number',
    sortable: false,
  },
];

function PackagePriceModal(props) {
  const { open, setOpen, order, setOrder, showNotify } = props;
  const classes = useStyles();

  const [processing, setProcessing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [details, setDetails] = useState([]);
  const [tableKey, setTableKey] = useState(1);

  function handleClose() {
    setProcessing(false);
    setOpen(false);
    setDetails([]);
  }

  async function onSave() {
    let editedDetails = details
      .filter((det) => det.edited)
      .map((det) => ({ num_line: det.num_line, package_discount: det.new_package_discount }));

    let entity = `ordm/order/${order.id}/package-price`;
    setSaving(true);
    let res = await wsUpdate(entity, {
      details: editedDetails,
    });
    setSaving(false);
    if (res.success) {
      showNotify(res.message);
      setOrder(res.data);
      handleClose();
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function getOrderDetails(id) {
    setProcessing(true);
    const res = await wsGet('ordm/order', id);
    setProcessing(false);
    if (res.success) {
      let dataDetails = res.data.details.map((detail) => {
        let originalPackageDiscount =
          ((detail.unit_price_without_igv -
            (detail.package_price_original || detail.package_price_without_igv)) /
            detail.unit_price_without_igv) *
          100;
        let packageDiscount =
          ((detail.unit_price_without_igv - detail.package_price_without_igv) /
            detail.unit_price_without_igv) *
          100;

        return {
          ...detail,
          TaxRate: detail.units_price / detail.unit_price_without_igv,
          package_price_without_igv:
            detail.package_price_original || detail.package_price_without_igv,
          new_package_price: detail.package_price_without_igv,
          original_package_discount: originalPackageDiscount,
          new_package_discount: packageDiscount,
          edited: false,
        };
      });
      setDetails(dataDetails);
    }
  }

  function editCell(e) {
    const { id, value } = e;
    if (value < 0) return;

    setDetails((details) => {
      const index = details.findIndex((det) => det.num_line === id);
      const newDetails = [...details];
      newDetails[index].new_package_discount = value;
      newDetails[index].new_package_price =
        newDetails[index].unit_price_without_igv -
        (newDetails[index].unit_price_without_igv / 100) * value;

      newDetails[index].edited =
        newDetails[index].new_package_price !==
        newDetails[index].package_price_without_igv;

      return newDetails;
    });
  }

  useEffect(() => {
    if (open === false) return;
    getOrderDetails(order.id);
  }, [order, open]);

  const [originalTotal, originalTotalIgv, newTotal, newTotalIgv] = useMemo(() => {
    if (details.length === 0) return [0, 0];

    let originalTotal = details.reduce((prev, current) => {
      let packagePrice = current.package_price_original || current.package_price_without_igv;
      return (
        prev +
        current.units * current.unit_price_without_igv +
        current.packages * current.units_package * packagePrice
      );
    }, 0);

    let originalTotalIgv = details.reduce((prev, current) => {
      let packagePrice = current.package_price_original * current.TaxRate || current.package_price;
      return (
        prev +
        current.units * current.units_price +
        current.packages * current.units_package * packagePrice
      );
    }, 0);

    let newTotal = details.reduce((prev, current) => {
      return (
        prev +
        current.units * current.unit_price_without_igv +
        current.packages * current.units_package * current.new_package_price
      );
    }, 0);

    let newTotalIgv = details.reduce((prev, current) => {
      return (
        prev +
        current.units * current.units_price +
        current.packages * current.units_package * (current.new_package_price * current.TaxRate)
      );
    }, 0);

    return [
      originalTotal.toFixed('2'),
      originalTotalIgv.toFixed('2'),
      newTotal.toFixed('2'),
      newTotalIgv.toFixed('2'),
    ];
  }, [details]);

  return (
    <ModalFull
      title={`Solicitud canal mayorista orden ${order.id}`}
      open={open}
      setOpen={handleClose}
    >
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={3}>
              <h6>Vendedor</h6>
              <h5>{order.SlpName}</h5>
            </GridItem>

            <GridItem xs={5}>
              <h6>Cliente:</h6>
              <h5>{order.CardName}</h5>
            </GridItem>

            <GridItem xs={12}>
              <h6>Comentario vendedor: </h6>
              <h5>{order.comment}</h5>
            </GridItem>
            {/* Total original */}
            <GridItem xs={12}>
              <GridContainer>
                <GridItem xs={6} lg={3} xl={2}>
                  <h6>Total original: </h6>
                  <h5>{originalTotalIgv}</h5>
                </GridItem>
                <GridItem xs={6} lg={3} xl={2}>
                  <h6>Total original (Sin igv): </h6>
                  <h5>{originalTotal}</h5>
                </GridItem>
              </GridContainer>
            </GridItem>
            {/* Nuevo total */}
            <GridItem xs={12}>
              <GridContainer>
                <GridItem xs={6} lg={3} xl={2}>
                  <h6>Nuevo Total: </h6>
                  <h5>{newTotalIgv}</h5>
                </GridItem>
                <GridItem xs={6} lg={3} xl={2}>
                  <h6>Nuevo Total (Sin igv): </h6>
                  <h5>{newTotal}</h5>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          {/* Tabla */}
          <GridContainer>
            <GridItem xs={12} style={{ height: '450px' }}>
              <DataGrid
                className={classes.dataGrid}
                getRowClassName={(params) => {
                  if (params.row.type === 'B') {
                    return 'row-bonification';
                  }
                }}
                loading={processing}
                key={tableKey}
                localeText={esES.props.MuiDataGrid.localeText}
                onCellEditCommit={editCell}
                getRowId={(row) => row.num_line}
                columns={columns}
                rows={details}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
              <Button color="success" onClick={onSave} disabled={saving}>
                Actualizar
              </Button>
              <Button color="danger" onClick={handleClose} disabled={saving}>
                Cancelar
              </Button>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </ModalFull>
  );
}

export default PackagePriceModal;
